import {Injectable} from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import {Observable} from 'rxjs';
import {environment} from '../../../../environments/environment';

@Injectable({
  providedIn:'root'
})
export class HttpApiService {
  private url = environment.baseUrl;
  
  constructor(private httpClient: HttpClient) {
  }
  
  public get<T>(path: string): Observable<T> {
    const headers = new HttpHeaders({
      'Content-Type':'application/json'
    });
    return this.httpClient.get<T>(`${this.url}/${path}`, {headers});
  }
}
